module.exports = __webpack_public_path__ + "img/Brian_King@2x.ee62909b.webp";